var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo, useCallback, useState, useRef } from 'react';
import { useMount, useUpdate } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
const prefixCls = createPrefixCls('switch');
export const Switch = (_a) => {
    var { style, className, color, size = 'normal', disabled, defaultChecked, checked, onChange, formValue, setFormValue } = _a, restProps = __rest(_a, ["style", "className", "color", "size", "disabled", "defaultChecked", "checked", "onChange", "formValue", "setFormValue"]);
    const defaultCheckedRef = useRef(defaultChecked);
    const getPropsChecked = useMemo(() => {
        if (checked !== undefined) {
            return checked;
        }
        else if (formValue !== undefined) {
            return formValue;
        }
        else {
            return undefined;
        }
    }, [checked, formValue]);
    const [isChecked, setIsChecked] = useState(getPropsChecked === undefined
        ? defaultCheckedRef.current === undefined
            ? false
            : defaultCheckedRef.current || false
        : getPropsChecked);
    useMount(() => {
        if (setFormValue) {
            if (checked !== undefined) {
                setFormValue(checked, false);
            }
            else if (defaultCheckedRef.current !== undefined) {
                setFormValue(defaultChecked, false);
            }
        }
    });
    // checked更新
    useUpdate(() => {
        setIsChecked(checked || false);
        setFormValue && setFormValue(checked);
    }, [checked]);
    // formValue更新，一般用来做重置操作，值为undefined
    useUpdate(() => {
        setIsChecked(checked || false);
    }, [formValue]);
    const handleClick = useCallback(() => {
        if (!disabled) {
            const newChecked = getPropsChecked === undefined ? !isChecked : !getPropsChecked;
            if (getPropsChecked === undefined) {
                setIsChecked(!isChecked);
            }
            onChange && onChange(newChecked);
            setFormValue && setFormValue(newChecked);
        }
    }, [disabled, getPropsChecked, isChecked, onChange, setFormValue]);
    const switchSty = useMemo(() => {
        return Object.assign({ backgroundColor: color && (checked || isChecked) ? color : undefined, borderColor: color && (checked || isChecked) ? color : undefined }, style);
    }, [color, checked, isChecked, style]);
    const switchCls = useMemo(() => {
        return classnames([
            prefixCls(),
            prefixCls(`size-${size}`),
            {
                [prefixCls('disabled')]: disabled
            },
            {
                [prefixCls('checked')]: getPropsChecked === undefined ? isChecked : getPropsChecked
            },
            className
        ]);
    }, [size, disabled, getPropsChecked, isChecked, className]);
    return React.createElement("div", Object.assign({ className: switchCls, style: switchSty, onClick: handleClick }, restProps));
};
